export default __webpack_public_path__ + "static/media/simrunChopra1.ec515ea8.jpg";